/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  

  // ---------------- Loyalty Banner | Rebuy + Smile Integration ----------------

  document.addEventListener('DOMContentLoaded', () => {
    



    
    
    document.addEventListener('rebuy:cart.add', (event) => { 
      const smartcart = Rebuy.SmartCart;
      console.log(smartcart);
      setTimeout(() => {
        smartcart.items().forEach(item => {
          if (item.product.tags.includes('online_professional_only') && !document.body.classList.contains('online-professional')) {
            smartcart.removeItem(item, console.log('removed'));
          } 
        });
      }, 500);
    });

    document.addEventListener('rebuy:smartcart.ready', (event) => {
      const smartcart = event.detail.smartcart;
      smartcart.items().forEach(item => {
        if(item.product.tags.includes('online_professional_only') && !document.body.classList.contains('online-professional')) {
          smartcart.removeItem(item, console.log('removed'));
        } 
      });

      // ---- Update Loyalty Banner ----

      const waitForSmile = setInterval(() => {
        if (window.Smile && typeof window.Smile.ready === 'function') {
          clearInterval(waitForSmile);
          window.Smile.ready().then(() => {
            const Smile = window.Smile;

            // Updating Loyalty Banner Points Balance
            let smilePointsContainer = document.querySelector('.smile-points--amount.smile-points-balance');
            
            // Check for Rewards Available
            const balance = Smile.customer?.points_balance ?? 0;
            const rewardTitle = document.querySelector('.smile-earning-progress-bar-reward-title');
            const progressBar = document.querySelector('.smile-earning-progress-bar');
            const smileCTA = document.querySelector('.smile-cta');
            

            Smile.fetchAllCustomerPointsProducts().then(pointsProducts => {
              console.log(pointsProducts)
            });
            Smile.fetchCustomer().then((customer) => {
              if (smilePointsContainer) {
                smilePointsContainer.innerHTML = customer.points_balance;
              }
            });
            
            Smile.fetchAllPointsProducts().then(pointsProducts => {
              if (smileCTA) {
                smileCTA.style.display = balance > 0 ? 'none' : '';
              }   
              // Determine last eligible reward
              
              setTimeout(() => {   
                // Hide progress bar if balance is less than first reward price
                if (pointsProducts.length > 0) {
                  const firstPrice = parseInt(pointsProducts[0].points_price, 10);
                  if (balance < firstPrice) {
                    if (progressBar) {
                      progressBar.style.display = 'none';
                    }
                    console.log('no rewards available');
                    return;
                  }
                }
                let lastEligibleRewardName = '';
                let maxEligiblePrice = -1;
                let found = false;
                for (const reward of pointsProducts) {
                  const price = reward.points_price;
                  const rewardName = reward.reward?.name ?? '';
                  console.log(price, rewardName);
                  if (balance >= price && price > maxEligiblePrice) {
                    maxEligiblePrice = price;
                    lastEligibleRewardName = rewardName;
                    found = true;
                  }
                }
                 // Update reward title or hide progress bar
              if (rewardTitle && lastEligibleRewardName) {
                rewardTitle.textContent = lastEligibleRewardName;
              } 
              }, 100);
            });
            let SmileUI = window.SmileUI;
            progressBar.addEventListener('click', (e) => {
              
              setTimeout(() => {
                smartcart.hide(e);
                
              }, 100);
            })
          });
        }
      }, 100);
 
      

      // ---- End Update Loyalty Banner ----
      
      // -- Update Rebuy Widget Prices
      const rebuyWidgetContent = document.querySelector('.rebuy-widget-content');
      if (!rebuyWidgetContent) return; 
      const localCurrency = smartcart.currency().toString();
      const rebuyPrices = rebuyWidgetContent.querySelectorAll('.rebuy-money');
      
      rebuyPrices.forEach(price => {  
          const secondSpan = price.querySelector('span:nth-of-type(2)');
          if (!secondSpan.innerHTML.includes(localCurrency)) {
              secondSpan.innerHTML = secondSpan.innerHTML + ' ' + localCurrency;
          }
        });

      // -- End Update Rebuy Widget Prices
      
    });


  });






  document.addEventListener('DOMContentLoaded', function () {
   


    if(window.location.pathname == '/pages/surface-rewards'){
    let toggleSmileModal = document.querySelectorAll('.toggle-smile-modal');
    let bodyContainer = document.querySelector('#surface-rewards');

      if(bodyContainer.classList.contains('customer-logged-in')){
        bodyContainer.querySelectorAll('a[href="/account/login"][aria-label="LOG IN TO REDEEM"]').forEach(button => {
          button.innerHTML = 'Ways to Redeem';
          button.setAttribute('href', '#smile-points-products');
        });
      }
      let openSmileModal = () => {
        let smileModal = document.querySelector('#surface-rewards #smile-ui-container');
        if (smileModal) {
          smileModal.classList.add('show-smile-modal');
        }
      }


    }
  });


  const secondaryMenuLinks = document.querySelectorAll('.secondary-menu-link');
  const secondaryMenuImages = document.querySelectorAll('.desktop-links-image');

  document.addEventListener('DOMContentLoaded', function() {

    let showImage = (linkTitle) => {
      secondaryMenuImages.forEach(image => {
        if (image.dataset.linkTitle === linkTitle) {
          image.classList.remove('hide');
        }
      });
    }

    let hideImage = () => {
      secondaryMenuImages.forEach(image => {
        image.classList.add('hide');
      });
    }

    secondaryMenuLinks.forEach(link => {
      link.addEventListener('mouseenter', function() {
        const linkTitle = link.dataset.linkTitle;
        showImage(linkTitle);
      });
      
      link.addEventListener('mouseleave', function() {
        hideImage();
      });
    });



    function processProductGridItem(item) {
      let optionsList = item.querySelector('.product-grid-popout__list');
      let optionsListOpenButton = item.querySelectorAll('.product-grid-popout__toggle');
      let atcButton = item.querySelectorAll('.product-atc-wrapper .product-atc-button');
      formatProductTileReviewText(item);
      optionsListOpenButton.forEach(button => {
        if (!button.classList.contains('options-listener-added')) {
          button.classList.add('options-listener-added');
          button.addEventListener('click', function() {
            optionsList.classList.toggle('select-popout__list--visible');
            item.classList.toggle('product-grid-item--options-visible');
          });
        }
      });
    }

    function getProductTileReviewCount(text, badge) {
      const countFromAttribute = badge?.dataset.numberOfReviews;
      if (countFromAttribute && !Number.isNaN(Number.parseInt(countFromAttribute, 10))) {
        return countFromAttribute;
      }

      const countFromText = text.match(/[\d,]+/);
      return countFromText ? countFromText[0] : '';
    }

    function observeProductTileReviewText(textElement) {
      if (textElement.dataset.reviewTextObserverAdded === 'true') return;

      const observer = new MutationObserver(() => {
        queueProductTileReviewTextFormat(textElement);
      });

      observer.observe(textElement, { childList: true, characterData: true, subtree: true });
      textElement.dataset.reviewTextObserverAdded = 'true';
    }

    function formatProductTileReviewText(root = document) {
      const selector = '.product-grid-item.fr-product-grid-item .jdgm-preview-badge .jdgm-prev-badge__text';
      const reviewTexts = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector);
      if (!reviewTexts || reviewTexts.length === 0) return;

      reviewTexts.forEach(textElement => {
        observeProductTileReviewText(textElement);

        const badge = textElement.closest('.jdgm-prev-badge');
        const currentText = textElement.textContent.trim();
        const collapsedText = textElement.dataset.collapsedReviewText;

        if (currentText && currentText !== collapsedText && !/^\([\d,]+\)$/.test(currentText)) {
          textElement.dataset.originalReviewText = currentText;
        }

        const originalText = textElement.dataset.originalReviewText || currentText;
        const reviewCount = getProductTileReviewCount(originalText, badge);
        if (!reviewCount) return;

        textElement.dataset.collapsedReviewText = `(${reviewCount})`;
        const nextText = window.innerWidth < 480 ? textElement.dataset.collapsedReviewText : originalText;

        if (textElement.textContent.trim() !== nextText) {
          textElement.textContent = nextText;
        }
      });
    }

    function queueProductTileReviewTextFormat(root = document) {
      requestAnimationFrame(() => formatProductTileReviewText(root));
    }
  
    function processOption(option) {
      if (!option.classList.contains('option-listener-added')) {
        option.classList.add('option-listener-added');
        option.addEventListener('click', function() {
          let is_pro = typeof WSAIO.isWholesaleCustomer == 'function' && WSAIO.isWholesaleCustomer();
          let buttonTextContent = option.closest('.select-popout').querySelector('.select-popout__value');
          let optionDropdown = option.closest('.product-grid-popout__list');
          let atcButton = option.closest('.product-atc-wrapper').querySelector('.product-atc-button');
          buttonTextContent.textContent = option.dataset.value;
          optionDropdown.classList.remove('select-popout__list--visible');
          optionDropdown.closest('.product-grid-item').classList.remove('product-grid-item--options-visible');
          atcButton.dataset.variantId = option.dataset.optionId;
          let currentItem = option.closest('.select-popout__list').querySelector('.select-popout__item--current');
          if (currentItem) {
            currentItem.classList.remove('select-popout__item--current');
          }
          option.parentElement.classList.add('select-popout__item--current');
                    
          let price = option.dataset.price;
          let parent_container = option.closest('.fr-product-grid-item--' + option.dataset.product_id);
          let price_container = parent_container.querySelector('.price');
          let discount_container = price_container.querySelector('s');
          if (!is_pro || !discount_container) {
              if (price && price_container) {
              let new_price = '';
              let compare_at_price = option.dataset.compare_at_price;
              if (compare_at_price) {
                new_price = '<span class="product__price--on-sale" data-product-price>';
                new_price += price;
                new_price += '</span>';
                new_price += '<span class="product-single__price--compare">'
                new_price += compare_at_price;
                new_price += '</span>';
              } else {
                new_price = price;
              }
              price_container.innerHTML = new_price;
            }
          }

        });
      }
    }
  
    let productGridItems = document.querySelectorAll('.product-grid-item.fr-product-grid-item');
    productGridItems.forEach(item => {
      processProductGridItem(item);
    });
    [100, 500, 1500, 3000].forEach(delay => {
      setTimeout(() => formatProductTileReviewText(), delay);
    });
    window.addEventListener('load', () => formatProductTileReviewText());
    window.addEventListener('resize', () => queueProductTileReviewTextFormat());
  
    let options = document.querySelectorAll('.select-popout__option');
    options.forEach(option => {
      processOption(option);
    });
  
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches('.product-grid-item.fr-product-grid-item')) {
                processProductGridItem(node);
              }
              else {
                node.querySelectorAll('.product-grid-item.fr-product-grid-item').forEach(item => {
                  processProductGridItem(item);
                });
              }
  
              if (node.matches('.select-popout__option')) {
                processOption(node);
              }
              else {
                node.querySelectorAll('.select-popout__option').forEach(option => {
                  processOption(option);
                });
              }

              queueProductTileReviewTextFormat(node);
            }
          });
        }
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });
  

  let atcButton = document.querySelectorAll('.product-atc-button');

  atcButton.forEach(button => {
    button.addEventListener('click', function(){
      const variantId = button.dataset.variantId;
      if (variantId) {
        addToCart(variantId);
      }
    });
  });


  const addToCart = (variantId) => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  const mobileCarouselArrows = document.querySelectorAll('.fr-carousel-button');
  const mobileCarousels = document.querySelectorAll('.fr-mobile-carousel');
  
  mobileCarouselArrows.forEach(arrow => {
    arrow.addEventListener('click', function () {
      const carouselSection = arrow.closest('.mobile-carousel-arrows__enabled');
      console.log('Carousel Section:', carouselSection);
      if (!carouselSection) {
        return;
      }
  
      const carousel = carouselSection.querySelector('.fr-mobile-carousel');
      console.log('Carousel:', carousel);
      if (!carousel) {
        return;
      }
  
      const carouselItems = Array.from(carousel.children);
      const totalItems = carouselItems.length;
      console.log('Total Items:', totalItems);
      if (totalItems === 0) {
        return;
      }
  
      const direction = arrow.classList.contains('next') ? 'next' : 'prev';
  
      // Get the carousel's scroll position and dimensions
      const scrollLeft = carousel.scrollLeft;
      const carouselWidth = carousel.offsetWidth;
      const carouselCenter = scrollLeft + carouselWidth / 2;
  
      // Find the item whose center is closest to the carousel center
      let closestIndex = 0;
      let closestDistance = Infinity;
  
      carouselItems.forEach((item, index) => {
        const itemLeft = item.offsetLeft;
        const itemWidth = item.offsetWidth;
        const itemCenter = itemLeft + itemWidth / 2;
        const distance = Math.abs(carouselCenter - itemCenter);
  
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
  
      console.log('Closest Index:', closestIndex);
  
      let nextIndex;
      if (direction === 'next') {
        nextIndex = closestIndex + 1;
        if (nextIndex >= totalItems) {
          nextIndex = 0; // Loop back to the first item
        }
      } else {
        nextIndex = closestIndex - 1;
        if (nextIndex < 0) {
          nextIndex = totalItems - 1; // Loop back to the last item
        }
      }
  
      console.log('Next Index:', nextIndex);
  
      const nextItem = carouselItems[nextIndex];
  
      if (!(nextItem instanceof Element)) {
        console.error('Next item is not an Element');
        return;
      }
  
      const newScrollPosition = nextItem.offsetLeft;
      console.log('New Scroll Position:', newScrollPosition);
  
      carousel.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth' // Smooth scrolling
      });
  
      console.log('Scroll triggered');
    });
  });
  

  // Video List Slider
  const videoListSliders = document.querySelectorAll('.fr-video-list-slider__section .fr-video-list-slider');
  const videoListVideos = document.querySelectorAll('.fr-video-list-slider__section .fr-video-item__inner');


  videoListSliders.forEach(slider => {
    const flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      cellSelector: '.fr-video-item'
    });
  });
  const pauseAllVideos = () => {
    videoListVideos.forEach(video => {
      const videoElement = video.querySelector('.fr-video-item__video');
      const videoPlayButton = video.querySelector('.fr-play-button--container');
      videoPlayButton.classList.remove('hide');
      videoElement.pause();
    });
  }

  const playVideo = (video) => {
    pauseAllVideos();
    const videoPlayButton = video.querySelector('.fr-play-button--container');
    const videoElement = video.querySelector('.fr-video-item__video');
    videoPlayButton.classList.add('hide');
    videoElement.play();
  }
  const pauseVideo = (video) => {
    const videoPlayButton = video.querySelector('.fr-play-button--container');
    const videoElement = video.querySelector('.fr-video-item__video');
    videoPlayButton.classList.remove('hide');
    videoElement.pause();
  }
  videoListVideos.forEach(video => {
    video.addEventListener('click', function() {
    const videoElement = video.querySelector('.fr-video-item__video');
    if (videoElement.paused) {
      playVideo(video);
    } else {
      pauseVideo(video);
    }
  });

  });

  const dashboardQuickLinksToggle = document.querySelector('.quick-link-toggle');
  const desktopStickyMenu = document.querySelector('.dashboard-sticky-menu');
  const desktopStickyMenuClose = document.querySelector('.desktop-sticky-menu__close');

  const closeDesktopStickyMenu = () => {
    desktopStickyMenu.classList.remove('active');
    dashboardQuickLinksToggle.classList.remove('sticky-menu-open');
  }
  const openDesktopStickyMenu = () => {
    desktopStickyMenu.classList.add('active');
    dashboardQuickLinksToggle.classList.add('sticky-menu-open');
  }

  if(desktopStickyMenuClose) {
    desktopStickyMenuClose.addEventListener('click', function() {
      closeDesktopStickyMenu();
    });
  }

  if(dashboardQuickLinksToggle) {
    dashboardQuickLinksToggle.addEventListener('click', function() {
      openDesktopStickyMenu();
    });
  }

  let lastScrollY = window.scrollY;
  const professionalDashboard = document.querySelector('#professional-dashboard');

  document.addEventListener('scroll', function() {
    if (professionalDashboard) {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;
      
      if (isScrollingUp && currentScrollY >= 20) {
        document.body.classList.add('has-scrolled-up');
      } else {
        document.body.classList.remove('has-scrolled-up');
      }
      
      lastScrollY = currentScrollY;
    }
  });

  const popoverElement = document.querySelector('.professional-dashboard--mobile');
  const popoverOpenButton = document.querySelector('.dashboard-popover-control');
  const popoverCloseButton = document.querySelector('.popover-close-button');

  
  if(popoverOpenButton) {
  popoverOpenButton.addEventListener('click', function() {
    gsap.to(popoverElement, {
      bottom: 0,
      duration: 0.5,
      ease: 'ease-in-out',

    });
  });
  }
  if(popoverCloseButton) {
  popoverCloseButton.addEventListener('click', function() {
    gsap.to(popoverElement, {
      bottom: '-200%',
      duration: 0.5,
      ease: 'ease-in-out',
      onComplete: () => {
        popoverElement.hidePopover();
      }
    });
  });
  }
  
  // Product Atc Variant Selector Open Animations
  let openProductAtcVariantSelector = document.querySelectorAll('.variant-select-button.product-grid-popout__toggle');
  let variantSelectTween = (element) => gsap.fromTo(element, 
    {
      height: 0,
      duration: 0.3,
      ease: 'ease-in-out',
    },
    {
      height: "auto",
      duration: 0.3,
      ease: 'ease-in-out',
    }
  );
  let checkIfOpen = (button) => {
    if (button.getAttribute('aria-expanded') === 'true') {
      variantSelectTween(button.nextElementSibling);
    } else {
      variantSelectTween(button.nextElementSibling);
    }
  }
  openProductAtcVariantSelector.forEach(button => {
    button.addEventListener('click', function() {
      checkIfOpen(button);
    });
  });

//.certification .text__button--article

  // Review Carousel Flickity
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const reviewCarousel = document.querySelector('.collection-reviews--block-wrapper');
    if(reviewCarousel){
        new Flickity(reviewCarousel, {
            cellAlign: isMobile ? 'center' : 'left',
            contain: true,
            pageDots: false,
        });
    }
        
    gsap.registerPlugin(ScrollToPlugin);

    const collectionPromo = document.querySelectorAll('.collection-promo__button button');
    const sectionToScrollTo = document.querySelector('#fr-collection-routine-block');
    const certficationLearnMore = document.querySelectorAll('.text__button--certification');
    // const videoBoxFirstChild = document.querySelectorAll('.video-box')[0];

    const scrollToAnimation = (elem, target) => {
      elem.forEach(button => {
        button.addEventListener('click', function() {
          gsap.to(window, {
            scrollTo: target,
            duration: 1,
            ease: 'power2.inOut',
          });
        });
      });
    }

    scrollToAnimation(collectionPromo, sectionToScrollTo);


   

    let klaviyoFormTrigger = document.querySelector('.klaviyo_form_trigger');
    if(klaviyoFormTrigger){
      klaviyoFormTrigger.addEventListener('click', function (){
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', 'U48Dzv']);
      });
    }

  //  Video Play Function
  const toggleVideoPlayStatus = (elem) => {
    const video = elem.querySelector('video');
    if(video.paused){
      setTimeout(() => {
      video.play();
      if(elem.querySelector('.button--wrapper')){
        elem.querySelector('.button--wrapper').classList.add('hide');
      }
      video.controls = true;
      }, 100);
     }else{
      setTimeout(() => {
      video.pause();
      if(elem.querySelector('.button--wrapper')){
        elem.querySelector('.button--wrapper').classList.remove('hide');
      }
      video.controls = false;
      }, 100);
     }  
  }

  const videoPlayButton = document.querySelectorAll('.fr-promotion-with-product__video--container');
  if(videoPlayButton){
    videoPlayButton.forEach(button => {
      button.addEventListener('click', function() {
        toggleVideoPlayStatus(button);
      });
    });
  }
   

})();
